import { writable } from "svelte/store";
import uuid from "../util/uuid.js";

const { subscribe, update } = writable([]);

function addToast(json) {
	const id = json.id || uuid();
	let added = false;
	update((toasts) => {
		if (toasts.find((t) => t.id === id)) return toasts;
		added = true;
		return [...toasts, { ...json, id }];
	});
	if (!added) return;
	setTimeout(() => {
		if (json.persist) return;
		update((toasts) => {
			const index = toasts.findIndex(
				(t) => (t.id = toasts.filter((t) => t.id === id))
			);
			if (index > -1) {
				toasts = [...toasts.slice(0, index), ...toasts.slice(index + 1)];
			}
			return toasts;
		});
	}, 5000);
}

export default { subscribe, addToast };
